import React from 'react';
import moment from 'moment';
export const options = {
  columns: [
    { id: 1, name: 's.no', label: 'S.No.', sortable: false, type: 'number' },
    // {
    //   id: 2, name: 'platformName', label: 'Platform', sortable: true, type: 'string',
    //   component: (row) => (<div>{row.platformName.toUpperCase()}</div>)
    // },
    { id: 3, name: 'attrName', label: 'Attributes Name', sortable: true, type: 'string' },
    {
      id: 4, name: 'attributeValuesList', label: 'Values', sortable: false, type: 'string',
      component: (row) =>
        (<div> {row.attributeValuesListDetail && row.attributeValuesListDetail.length && row.attributeValuesListDetail.map((a, i) => <div key={i}>{a}</div>)}</div>)
    },
    {
      id: 2, name: 'modifyOn', label: 'Modified On', sortable: true, type: 'string',
      component: (row) => row.modifyOn ? moment(row.modifyOn).format('DD-MMM-YY'):""
    },
  ],

  keyCol: 'aId',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Edit'
  }
  ],
  actionsThead: true,
  sortable: true,
  dateType: true,
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  showSearch: true,
  searchable: true,
  searchColumns: [
    { key: 'attrName' },
    { key: 'attributeValuesList' }
  ],
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};
